<span class="badge" [ngClass]="badgeClass">{{ translatedDifficulty }}</span>
